import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "lg:hidden fixed -bottom-1 right-0 left-0 z-30 animate-fade"
}
const _hoisted_2 = { class: "mobile-nav bg-white flex text-secondary rounded-t-md" }
const _hoisted_3 = ["href", "aria-label"]
const _hoisted_4 = { class: "hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_ctx.links.length && !_ctx.hidden)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
            return (_openBlock(), _createElementBlock("a", {
              key: link.label,
              href: link.href,
              class: "flex-1 p-5 hover:text-secondary border-complementary flex justify-center",
              "aria-label": link.aria
            }, [
              _createVNode(_component_FontAwesomeIcon, {
                class: "w-5 h-5",
                icon: link.icon
              }, null, 8, ["icon"]),
              _createElementVNode("span", _hoisted_4, _toDisplayString(link.label), 1)
            ], 8, _hoisted_3))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}